<template>
  <v-card>
    <v-card-title class="dialog-header"
      ><span>Change password</span>
      <v-icon color="#0068B5" size="25" @click="close">mdi-close</v-icon>
    </v-card-title>
    <v-form ref="form" v-model="isFormValid">
      <v-text-field
        autofocus
        v-model="oldPassword"
        :rules="[isRequired]"
        type="password"
        variant="outlined"
        color="primary"
      >
        <template v-slot:prepend>
          <div>Old Password</div>
        </template>
      </v-text-field>
      <v-text-field
        :messages="['Minimum of 8 characters']"
        v-model="newPassword"
        :rules="[passwordValidation]"
        type="password"
        variant="outlined"
        color="primary"
      >
        <template v-slot:prepend>
          <div>New Password</div>
        </template>
        <template v-slot:message>
          <div
            :class="{
              'message-color': isLengthAccepted(newPassword) || newPassword.length === 0,
              'error-message': !isLengthAccepted(newPassword) && newPassword.length > 0,
            }"
          >
            Minimum of 8 characters
          </div>
          <div
            :class="{
              'message-color':
                (isCapitalized(newPassword) && isLowerCase(newPassword)) ||
                newPassword.length === 0,
              'error-message':
                !(isCapitalized(newPassword) && isLowerCase(newPassword)) && newPassword.length > 0,
            }"
          >
            At least one uppercase and lowercase letter
          </div>
          <div
            :class="{
              'message-color': isSignExists(newPassword) || newPassword.length === 0,
              'error-message': !isSignExists(newPassword) && newPassword.length > 0,
            }"
          >
            At least one special character
          </div>
        </template>
      </v-text-field>

      <v-text-field
        ref="confirmPass"
        v-model="newPasswordRepeat"
        autocomplete="new-password"
        :rules="[isPasswordConfirmed]"
        type="password"
        variant="outlined"
        color="primary"
      >
        <template v-slot:prepend>
          <div>Repeat New Password</div>
        </template>
      </v-text-field>
    </v-form>

    <v-card-actions>
      <v-btn class="custom-btn" color="primary" @click="handleClickConfirm"
        >Change password
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" src="./index.ts"></script>

<style scoped lang="scss" src="./index.scss"></style>
